import React, { Fragment } from "react";

import img13 from "../../../images/service/Ethereum Blockchain Development/1.png";
import img14 from "../../../images/service/Ethereum Blockchain Development/2.png";
import img15 from "../../../images/service/Ethereum Blockchain Development/3.png";
// Service icons
import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

// Common Components
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";
import Industries from "../../../components/Industries/Industries";
import TheorySection from "../../../components/PageSection/Theory";

// =====================
// DATA
// =====================

const serviceCards = [
  {
    icon: sIcon1,
    title: "Ethereum dApp Development",
    content:
      "Design and build decentralized applications on Ethereum with secure smart contracts and scalable architecture.",
  },
  {
    icon: sIcon2,
    title: "Smart Contract Development",
    content:
      "Develop, test, and deploy Solidity smart contracts that power secure and transparent blockchain applications.",
  },
  {
    icon: sIcon3,
    title: "Token & NFT Development",
    content:
      "Create ERC-20, ERC-721, and ERC-1155 tokens for DeFi platforms, NFTs, and digital assets.",
  },
];

const benefits = [
  {
    title: "Proven Blockchain Network",
    description:
      "Ethereum is the most widely adopted blockchain with a strong global developer ecosystem.",
    icon: sIcon1,
  },
  {
    title: "Smart Contract Flexibility",
    description:
      "Highly programmable smart contracts enable complex decentralized applications.",
    icon: sIcon2,
  },
  {
    title: "Robust Security",
    description:
      "Battle-tested infrastructure with strong cryptographic security.",
    icon: sIcon3,
  },
  {
    title: "Ecosystem & Tooling",
    description:
      "Extensive tools, frameworks, and Layer-2 solutions support scalable development.",
    icon: sIcon4,
  },
];

const faqs = [
  {
    q: "Why choose Ethereum for blockchain development?",
    a: "Ethereum offers a mature ecosystem, flexible smart contracts, and widespread adoption across DeFi, NFTs, and Web3 applications.",
  },
  {
    q: "Do you develop Solidity smart contracts?",
    a: "Yes. We design, develop, and audit Solidity smart contracts tailored to your business logic.",
  },
  {
    q: "Can Ethereum handle large-scale applications?",
    a: "Yes. With Layer-2 solutions and optimized architecture, Ethereum supports scalable applications.",
  },
  {
    q: "Is Ethereum suitable for enterprise use?",
    a: "Absolutely. Ethereum is widely used for enterprise blockchain solutions and decentralized finance platforms.",
  },
];

// =====================
// PAGE COMPONENT
// =====================

export default function EthereumBlockchainDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Ethereum Blockchain Development"
        pagesub="Secure, scalable & industry-leading Ethereum solutions"
      />

      {/* HERO SECTION */}
      <HeroSection
        title={
          <>
            Build Powerful dApps on{" "}
            <span className="gradient-text">Ethereum Blockchain</span>
          </>
        }
        subtitle={`Leverage Ethereum’s smart contract capabilities to build
secure, decentralized, and enterprise-ready blockchain applications.`}
        buttonText="Book Consultation"
        buttonLink="/contact"
        image={img13}
        imageAlt="Ethereum Blockchain Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="Why Choose Ethereum Blockchain?"
        image={img14}
        paragraphs={[
          "Ethereum is the foundation of decentralized application development, powering thousands of DeFi, NFT, and Web3 platforms worldwide.",
          "Its programmable smart contracts and large developer ecosystem make Ethereum the preferred choice for building secure and flexible blockchain solutions.",
        ]}
      />

      {/* SERVICES */}
      <ServiceCardsSection
        title="Our Ethereum Blockchain Development Services"
        cards={serviceCards}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Challenges with Traditional Application Models"
        image={img15}
        paragraphs={[
          "Centralized systems suffer from single points of failure, limited transparency, and data ownership issues.",
          "Ethereum replaces centralized trust with decentralized smart contracts, enabling transparent and autonomous execution of business logic.",
        ]}
      />

      {/* BENEFITS */}
      <Benefit
        title="Benefits of Ethereum Blockchain Development"
        benefits={benefits}
      />

      {/* KEY FEATURES */}
      <KeyFeaturesSection
        title="Key Features of Our Ethereum Solutions"
        subtitle="Built for flexibility, security, and Web3 innovation"
        features={[
          {
            icon: sIcon1,
            title: "Solidity Smart Contracts",
            description:
              "Robust and flexible smart contract development.",
          },
          {
            icon: sIcon2,
            title: "ERC Token Standards",
            description:
              "Support for ERC-20, ERC-721, and ERC-1155 standards.",
          },
          {
            icon: sIcon3,
            title: "Layer-2 Scalability",
            description:
              "Optimized solutions using rollups and sidechains.",
          },
          {
            icon: sIcon4,
            title: "DeFi & NFT Ecosystem",
            description:
              "Build decentralized finance and NFT platforms.",
          },
          {
            icon: sIcon5,
            title: "Enterprise Integration",
            description:
              "Integrate Ethereum with existing enterprise systems.",
          },
          {
            icon: sIcon6,
            title: "Security Best Practices",
            description:
              "Audited, secure, and reliable blockchain solutions.",
          },
        ]}
      />

      <Industries />

      {/* WHY CHOOSE US */}
      <WhyChooseUsSection
        items={[
          "Deep expertise in Ethereum & Solidity",
          "Enterprise-grade blockchain engineering",
          "End-to-end Ethereum development services",
        ]}
      />

      {/* FAQ */}
      <FaqSection faqs={faqs} />

      {/* FINAL CTA */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
